import { formatCurrency } from '@/pages/table/utils/utils';
import CurrencyIcon from '@/components/CurrencySymbolMask/CurrencyIcon';
import React, { FC } from 'react';

interface CurrencyLabelProps {
  amount: number;
  shouldDisplayInBB: boolean;
  bigBlindValue: number;
}
const CurrencyLabel: FC<CurrencyLabelProps> = ({ amount, shouldDisplayInBB, bigBlindValue }) => {
  return shouldDisplayInBB && bigBlindValue ? (
    ` ${formatCurrency(amount! / bigBlindValue)} BB`
  ) : (
    <>
      <CurrencyIcon />
      {formatCurrency(amount)}
    </>
  );
};

export default CurrencyLabel;
